import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptySubscription = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 300 300",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 191.09,
			cy: 116.46,
			r: 97.41,
			fill: "var(--primary)",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M180.8 86.8a87 87 0 0 1 28.54-20.21 87 87 0 0 1 41.14-7c2.23.81 5.8 2.5 8.92 5.94 6.83 7.53 5.87 17.21 5.67 18.93z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m177.34 88.35 2.4-2.55a88 88 0 0 1 29.02-20.55 89 89 0 0 1 41.82-7.13l.2.02.2.07a24 24 0 0 1 9.5 6.34c6.89 7.59 6.37 17.29 6.05 20.08l-.15 1.26zm66.87-27.53a86 86 0 0 0-34.28 7.1 85 85 0 0 0-25.56 17.31l79.36-2.2c.19-3.42-.14-10.7-5.41-16.52a21 21 0 0 0-8.15-5.48q-2.74-.2-5.96-.21"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "M185.16 237.14c2.5-2.85.84-7.75-2.46-9.6-3.3-1.87-7.45-1.36-11.02-.1-14.23 5.04-22.72 22.4-17.97 36.73s21.95 23.16 36.36 18.69c5.68-1.76 10.7-5.23 15.07-9.25 5.2-4.79 9.66-10.51 12.3-17.07 4.87-12.02 3.3-25.66.14-38.24-4.58-18.25-12.3-35.6-16.77-53.89a157 157 0 0 1-3.72-52.65c.87-8.81 2.53-17.68 6.46-25.61 8.46-17.1 28.06-25.39 46.93-26.57L107 53.94C87.98 52.39 68.54 63.4 60.07 80.5c-3.93 7.94-4.88 16.9-6.46 25.61-3.05 16.78-5.3 105.54 12.07 126.64"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M182.11 285.5c-12.9 0-25.64-8.4-29.78-20.87-5.05-15.2 3.77-33.22 18.86-38.56 3.33-1.18 8.15-2.1 12.23.19a9 9 0 0 1 4.3 6.2 6.7 6.7 0 0 1-1.46 5.64 1.46 1.46 0 1 1-2.2-1.92c.97-1.1.9-2.5.78-3.23a6 6 0 0 0-2.86-4.14c-3.11-1.76-7.05-.96-9.8.01-13.42 4.75-21.56 21.38-17.08 34.89 4.49 13.5 20.95 21.97 34.54 17.75 4.89-1.52 9.64-4.44 14.52-8.93 5.55-5.1 9.56-10.67 11.93-16.54 3.98-9.83 4-21.7.07-37.33-2.23-8.9-5.28-17.77-8.23-26.34-3.07-8.94-6.25-18.2-8.54-27.56a158 158 0 0 1-3.76-53.15c.68-6.85 2.1-17.01 6.6-26.11 6-12.11 18.03-20.96 33.44-25.04L106.95 55.4c-18.62-1.51-37.32 9.08-45.57 25.75-3.13 6.33-4.35 13.56-5.52 20.55l-.8 4.68c-2.86 15.67-5.2 104.87 11.75 125.44a1.46 1.46 0 0 1-2.26 1.86c-17.54-21.3-15.63-109.96-12.38-127.83q.42-2.31.8-4.64c1.22-7.2 2.47-14.64 5.8-21.36 8.76-17.71 28.65-28.96 48.35-27.37l143.42 5.64a1.46 1.46 0 0 1 .03 2.92c-21.3 1.33-38.39 10.96-45.71 25.75-3.27 6.6-5.27 14.58-6.32 25.11a155 155 0 0 0 3.7 52.16c2.25 9.24 5.4 18.43 8.46 27.3 2.97 8.64 6.04 17.56 8.3 26.58 4.09 16.27 4.02 28.71-.2 39.15-2.53 6.27-6.8 12.19-12.66 17.6-5.2 4.79-10.32 7.91-15.63 9.56a28 28 0 0 1-8.4 1.26Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m183.34 283.93-129.02-4.3a41.93 41.93 0 0 1-40.48-43.35 16 16 0 0 1 16.53-15.44l148.87 5.57c-17.68-.68-30 18.39-27.33 34.04 2.64 14.32 15.9 22.96 31.43 23.48"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M183.34 285.39h-.05l-129.02-4.3a43 43 0 0 1-30.24-13.75 43 43 0 0 1-11.65-31.1c.16-4.67 2.12-8.98 5.53-12.17s7.85-4.84 12.51-4.69l148.8 5.57h.07a1.46 1.46 0 1 1-.1 2.93h-.01c-6.94-.27-13.55 2.74-18.6 8.49-5.83 6.65-8.6 15.78-7.23 23.84 2.4 12.99 14.2 21.73 30.04 22.26a1.46 1.46 0 0 1-.05 2.92m-153.53-63.1c-3.69 0-7.19 1.39-9.9 3.92a14.4 14.4 0 0 0-4.6 10.12 40.2 40.2 0 0 0 10.86 29 40.2 40.2 0 0 0 28.2 12.83l113.56 3.79c-9.21-4.15-15.7-11.73-17.46-21.23-1.52-8.93 1.52-19 7.92-26.29a29 29 0 0 1 9.06-7L30.32 222.3zM73.1 100.01l22.75.77m-22.87 3.09.26-7.71 22.75.77-.27 7.72zm32.71-2.75 83.1 2.84m-83.24 1.02.27-7.72 83.1 2.84-.27 7.72zm-32.45-4.97 22.75.77"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m72.98 103.87.26-7.71 22.75.77-.27 7.72zm32.71-2.75 83.1 2.84m-83.24 1.02.27-7.72 83.1 2.84-.27 7.72zm-33.8 18.28 22.74.78m-22.87 3.08.26-7.71 22.75.77-.27 7.72zm32.72-2.74 83.1 2.83m-83.24 1.02.27-7.71 83.1 2.83-.26 7.72zm-33.7 18.94 22.75.78m-22.88 3.08.26-7.71 22.75.77-.27 7.72zm32.72-2.75 83.1 2.84m-83.24 1.02.27-7.71 83.1 2.83-.26 7.72zm-33.6 17.17 22.75.77m-22.88 3.09.27-7.72 22.74.78-.26 7.72zm-.61 14.22 126.52 4.33m-126.65-.46.27-7.72 126.51 4.32-.26 7.72zm-.3 14.62 127.49 4.35m-127.63-.49.27-7.72 127.48 4.36-.26 7.71zm33.9-39.32 83.1 2.84m-83.24 1.02.27-7.72 83.1 2.84-.27 7.72zm87.25-85.03L73 85.86a28.5 28.5 0 0 1 6.57-14.49 28.4 28.4 0 0 1 13.13-8.48c2.16-.67 4.42-.96 6.68-.89 35.1 1.23 70.28 2.77 105.69 4a46.6 46.6 0 0 0-16.03 23.25Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 90.9,
			height: 71.59,
			x: 160.9,
			y: 111.38,
			fill: "var(--foreground)",
			rx: 6.57,
			ry: 6.57
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M245.23 184.17h-77.75a7.8 7.8 0 0 1-7.78-7.77v-58.45a7.8 7.8 0 0 1 7.78-7.77h77.75a7.8 7.8 0 0 1 7.77 7.77v58.45a7.8 7.8 0 0 1-7.77 7.77m-77.75-71.6a5.4 5.4 0 0 0-5.38 5.38v58.45a5.4 5.4 0 0 0 5.38 5.37h77.75a5.4 5.4 0 0 0 5.37-5.37v-58.45a5.4 5.4 0 0 0-5.37-5.37z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 90.9,
			height: 71.59,
			x: 153.16,
			y: 111.38,
			fill: "var(--card)",
			rx: 6.57,
			ry: 6.57
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M237.5 184.17h-77.76a7.8 7.8 0 0 1-7.78-7.77v-58.45a7.8 7.8 0 0 1 7.78-7.77h77.75a7.8 7.8 0 0 1 7.77 7.77v58.45a7.8 7.8 0 0 1-7.77 7.77m-77.76-71.6a5.4 5.4 0 0 0-5.38 5.38v58.45a5.4 5.4 0 0 0 5.38 5.37h77.75a5.4 5.4 0 0 0 5.37-5.37v-58.45a5.4 5.4 0 0 0-5.37-5.37z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M221.16 140.97h-50.12v-10.05h31.68v-8.77a5.03 5.03 0 0 1 8.63-3.5l13.41 13.8a5.03 5.03 0 0 1-3.6 8.52m-45.09 10.54h50.12v10.05H194.5v8.77a5.03 5.03 0 0 1-8.63 3.5l-13.41-13.8a5.03 5.03 0 0 1 3.6-8.52"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 70.5,
			cy: 68.14,
			r: 30.39,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M70.5 99.86c-17.49 0-31.72-14.23-31.72-31.72S53.01 36.43 70.5 36.43s31.72 14.22 31.72 31.71S87.99 99.86 70.5 99.86m0-60.78c-16.02 0-29.06 13.04-29.06 29.06S54.48 97.21 70.5 97.21s29.07-13.04 29.07-29.07S86.53 39.08 70.5 39.08"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 65.63,
			cy: 68.14,
			r: 30.39,
			fill: "var(--card)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M65.63 99.86c-17.5 0-31.72-14.23-31.72-31.72s14.23-31.71 31.72-31.71 31.72 14.22 31.72 31.71-14.23 31.72-31.72 31.72m0-60.78c-16.03 0-29.07 13.04-29.07 29.06S49.6 97.21 65.63 97.21s29.06-13.04 29.06-29.07-13.04-29.06-29.06-29.06"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M54.07 53.3q3.6-5.36 11.62-5.36c8.02 0 9.22 1.8 11.62 5.37s3.6 8.47 3.6 14.68q0 9.43-3.6 14.8c-3.6 5.36-6.27 5.36-11.62 5.36s-9.22-1.8-11.62-5.37-3.6-8.5-3.6-14.79q0-9.31 3.6-14.68m16.55 6.27q-1.2-2.96-4.93-2.96c-3.73 0-4.14.99-4.93 2.96q-1.2 2.94-1.2 8.42 0 3.69.44 6.1t1.76 3.9q1.34 1.5 3.93 1.49c2.59-.01 3.04-.5 3.93-1.5a8 8 0 0 0 1.76-3.9q.43-2.4.43-6.09 0-5.48-1.19-8.42"
		})
	]
});
export default SvgEmptySubscription;
